import { render } from "./StakeholderManagement.vue?vue&type=template&id=3610608d"
import script from "./StakeholderManagement.vue?vue&type=script&lang=js"
export * from "./StakeholderManagement.vue?vue&type=script&lang=js"

import "./StakeholderManagement.vue?vue&type=style&index=0&id=3610608d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__